import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { AxiosInstance } from 'axios';
import type { StatusBoardApiEnvelope } from '@/shared/api/status-board';
import type { ServiceStatusResponse } from './types';

import { useStatusBoardApi } from '@/shared/api/status-board';
import { useRegionEndpoint } from '@/shared/hooks';

export interface GetServiceStatusRequest {
  serviceName?: string;
  sort?: string;
}

/**
 * Status Board 서비스 상태 목록을 조회한다.
 * @description
 * - `/api/console/service-status` 엔드포인트를 호출하고 응답 래퍼의 `data`를 언래핑한다.
 */
export const getServiceStatus = async (
  instance: AxiosInstance,
  params?: GetServiceStatusRequest,
): Promise<ServiceStatusResponse> => {
  const response = await instance.get<StatusBoardApiEnvelope<ServiceStatusResponse>>(
    '/api/console/service-status',
    { params },
  );

  return response.data.data;
};

/**
 * 서비스 상태 목록 조회 React Query 훅.
 * @description
 * - 서비스 이름 필터와 정렬 조건을 API 파라미터로 전달한다.
 * @example
 * const { data, isLoading, refetch } = useGetServiceStatus();
 */
const useGetServiceStatus = (params?: GetServiceStatusRequest) => {
  const { instance } = useStatusBoardApi();
  const { currentRegion } = useRegionEndpoint();

  return useQuery({
    queryKey: ['useGetServiceStatus', currentRegion, params ?? {}],
    queryFn: () => getServiceStatus(instance, params),
    placeholderData: keepPreviousData,
  });
};

export default useGetServiceStatus;
